<script>
import accordionItem from '@components/accordian-item'
export default {
  components: {
    accordionItem: accordionItem,
  },
  props: {
    content: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupId: null,
    }
  },
  mounted() {
    this.groupId = this.$el.id
  },
}
</script>
<template>
  <dl class="accordion box" role="presentation">
    <accordionItem
      v-for="item in content"
      :key="item.id"
      :multiple="multiple"
      :item="item"
      :group-id="groupId"
    ></accordionItem>
  </dl>
</template>

<style scoped>
.accordion {
  width: 100%;
}
</style>
